import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_sharing'

export default function DreamSharingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you want your dreams to be...',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamSharing.heading')}
      buttons={[
        {
          text: `🫣 ${t('pages.onboarding.dreamSharing.options.justForMe')}`,
          value: 'Just for me, please Some dreams are private spells',
          subtext: t('pages.onboarding.dreamSharing.subtexts.justForMe'),
        },
        {
          text: `📸 ${t('pages.onboarding.dreamSharing.options.sharedSometimes')}`,
          value: 'Shared sometimes Some dreams want to be seen',
          subtext: t('pages.onboarding.dreamSharing.subtexts.sharedSometimes'),
        },
        {
          text: `✨ ${t('pages.onboarding.dreamSharing.options.sharedAlways')}`,
          value: 'Shared always Let others dream with me',
          subtext: t('pages.onboarding.dreamSharing.subtexts.sharedAlways'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
